import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_SAVED_SCHEMA = Object.freeze({
  PREVIOUSLY_EXISTED: false,
});
const RECORD = generateSchema(TRACKING_SAVED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SAVED_SCHEMA);

export class SavedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.saved;
  }

  get properties() {
    return this.toJS();
  }
}
